if (!customElements.get("m-featured-collection")) {
  class MFeaturedCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        loadMoreBtn: "[data-load-more]",
        loadMoreBtnWrapper: ".m-featured-collection__button",
        productsContainer: "[data-products-container]",
        products: [".m-product-card"],
        soldNumber: ["[data-sold-number]"],
        availableNumber: ["[data-available-number]"],
        countDown: "[data-flashsale-countdown]",
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.buttonType = this.dataset.buttonType;
      this.infiniteLoad = this.dataset.infiniteLoad;
      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.enableFlashsale = this.dataset.enableFlashsale === "true";
      this.enableCountdown = this.dataset.enableCountdown === "true";
      this.id = this.dataset.id;
      this.items = this.dataset.items;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });

      if (this.enableFlashsale) this.initFlashSale();

      this.canLoad = true;
      this.currentPage = 1;
      this.spinner = spinner();

      if (!this.enableSlider && this.buttonType === "load" && this.infiniteLoad === "true") {
        this.initInfiniteLoad();
      }
      if (!this.enableSlider && this.buttonType === "load") {
        this.initLoadMore();
      }
      if (
        MinimogTheme.config.mqlMobile &&
        this.mobileDisableSlider &&
        this.buttonType === "load" &&
        this.infiniteLoad === "true"
      ) {
        this.initInfiniteLoad();
      }
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider && this.buttonType === "load") {
        this.initLoadMore();
      }

      document.addEventListener("matchMobile", () => {
        if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider && this.buttonType === "load") {
          this.initLoadMore();
        }
        if (
          MinimogTheme.config.mqlMobile &&
          this.mobileDisableSlider &&
          this.buttonType === "load" &&
          this.infiniteLoad === "true"
        ) {
          this.initInfiniteLoad();
        }
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        if (this._featuredMediaResizeObs) {
          try {
            this._featuredMediaResizeObs.disconnect();
          } catch (e) {}
          this._featuredMediaResizeObs = null;
        }
        if (this._onFeaturedPrev) {
          const prevB = this.querySelector(".m-slider-controls__button-prev");
          const nextB = this.querySelector(".m-slider-controls__button-next");
          prevB && prevB.removeEventListener("click", this._onFeaturedPrev);
          nextB && nextB.removeEventListener("click", this._onFeaturedNext);
          this._onFeaturedPrev = null;
          this._onFeaturedNext = null;
        }
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper-container");
        if (this.swiper) this.swiper.destroy(false, true);
        this.swiper = null;
        this.slider = null;
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    /** Środek strzałek w pionie = środek pierwszego kafla obrazka (Minimog używa --offset-top / --swiper-container-offset-top). */
    syncFeaturedSliderControlsOffset(controlsContainer, prevButton, nextButton) {
      if (!controlsContainer) return;
      const firstItem =
        this.querySelector(".m-product-card__media") ||
        this.querySelector("responsive-image.m-image") ||
        this.querySelector(".m-image") ||
        this.querySelector(".m-placeholder-svg");
      if (!firstItem) return;
      const halfPx = Math.max(0, Math.round(firstItem.clientHeight / 2)) + "px";
      controlsContainer.style.setProperty("--offset-top", halfPx);
      controlsContainer.style.setProperty("--swiper-container-offset-top", halfPx);
      prevButton && prevButton.classList.remove("m:hidden");
      nextButton && nextButton.classList.remove("m:hidden");
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      if (!slideContainer) return;

      // Unikaj podwójnej inicjalizacji Swipera (matchMobile / resize) — to psuje kolumny i słuchacze strzałek
      if (slideContainer.swiper) {
        slideContainer.swiper.destroy(true, true);
        this.swiper = null;
        this.slider = null;
      }
      if (this._onFeaturedPrev) {
        const prevB = this.querySelector(".m-slider-controls__button-prev");
        const nextB = this.querySelector(".m-slider-controls__button-next");
        prevB && prevB.removeEventListener("click", this._onFeaturedPrev);
        nextB && nextB.removeEventListener("click", this._onFeaturedNext);
        this._onFeaturedPrev = null;
        this._onFeaturedNext = null;
      }
      if (this._featuredMediaResizeObs) {
        try {
          this._featuredMediaResizeObs.disconnect();
        } catch (e) {}
        this._featuredMediaResizeObs = null;
      }

      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const wrapper = slideContainer.querySelector(".swiper-wrapper");
      const slideItemsLength = wrapper ? wrapper.childElementCount : 0;

      const itemGap = parseInt(this.dataset.itemGap || "0", 10) || 0;
      const perRow = parseInt(this.items, 10) || 4;
      // Pętla tylko gdy jest co przewijać; przy za małej liczbie slajdów pętla psuje galerię
      const useLoop = !this.enableFlashsale && slideItemsLength > perRow;

      slideContainer.classList.add("swiper-container");

      /** Nie polegamy na drugim argumencie `breakpoint` Swipera (bywa undefined) — to chowało strzałki i zamykało swiper. */
      const syncFeaturedNavVisibility = (swiper) => {
        if (!controlsContainer || !swiper) return;
        let spv = swiper.params.slidesPerView;
        if (spv === "auto") {
          spv = slideItemsLength;
        }
        spv = Number(spv);
        if (!Number.isFinite(spv) || spv < 1) {
          spv = 1;
        }
        if (slideItemsLength > spv) {
          controlsContainer.classList.remove("m:hidden");
          swiper.allowTouchMove = true;
        } else {
          controlsContainer.classList.add("m:hidden");
          swiper.allowTouchMove = false;
        }
      };

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2,
        spaceBetween: itemGap,
        slidesPerGroup: 1,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: useLoop,
        // Round-2 mobile fix: zawsze pozwalamy palcem swipe'ować jeśli jest więcej niż 1 slide.
        // Bez tego na slajdach typu 2 perRow + 2-3 produkty Swiper wyłączał gesture.
        allowTouchMove: slideItemsLength > 1,
        simulateTouch: true,
        touchStartPreventDefault: false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              dynamicBullets: true,
              dynamicMainBullets: 5,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: perRow >= 3 ? 3 : perRow,
            spaceBetween: itemGap,
          },
          1024: {
            slidesPerView: perRow >= 4 ? 4 : perRow,
            spaceBetween: itemGap,
          },
          1280: {
            slidesPerView: perRow,
            spaceBetween: itemGap,
          },
        },
        threshold: 2,
        on: {
          init: () => {
            const bindResize = () => {
              this.syncFeaturedSliderControlsOffset(controlsContainer, prevButton, nextButton);
            };
            const firstOffsetTarget =
              this.querySelector(".m-product-card__media") ||
              this.querySelector("responsive-image.m-image") ||
              this.querySelector(".m-image") ||
              this.querySelector(".m-placeholder-svg");
            if (firstOffsetTarget && controlsContainer && window.ResizeObserver) {
              this._featuredMediaResizeObs = new ResizeObserver(() => {
                requestAnimationFrame(bindResize);
              });
              this._featuredMediaResizeObs.observe(firstOffsetTarget);
            }
            if (firstOffsetTarget) {
              firstOffsetTarget.querySelectorAll("img").forEach((img) => {
                if (!img.complete) img.addEventListener("load", bindResize, { once: true });
              });
            }
            setTimeout(() => {
              bindResize();
              if (this.slider) {
                this.slider.update();
                this.slider.updateSize();
                syncFeaturedNavVisibility(this.slider);
                bindResize();
                window.dispatchEvent(new Event("resize"));
              }
            }, 200);
          },
          breakpoint: (swiper) => {
            syncFeaturedNavVisibility(swiper);
            requestAnimationFrame(() =>
              this.syncFeaturedSliderControlsOffset(controlsContainer, prevButton, nextButton)
            );
          },
        },
      });

      this.swiper = slideContainer.swiper;
      this.slider = this.swiper;
      syncFeaturedNavVisibility(this.slider);

      if (this.slider && this.showNavigation && prevButton && nextButton) {
        this._onFeaturedPrev = () => this.slider && this.slider.slidePrev();
        this._onFeaturedNext = () => this.slider && this.slider.slideNext();
        prevButton.addEventListener("click", this._onFeaturedPrev);
        nextButton.addEventListener("click", this._onFeaturedNext);
      }
    }

    initLoadMore() {
      this.triggerLoad = false;
      this.totalPages = parseInt(this.dataset.totalPages);

      addEventDelegate({
        context: this.container,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore();
        },
      });
    }

    initInfiniteLoad() {
      const maxPages = this.dataset.maxPages;

      window.addEventListener("scroll", (e) => {
        this.canLoad = this.currentPage < parseInt(maxPages);

        if (!this.canLoad) return;
        if (this.offsetTop + this.clientHeight - window.innerHeight < window.scrollY && !this.triggerLoad) {
          this.triggerLoad = true;
          this.handleLoadMore();
        }
      });
    }

    async handleLoadMore() {
      this.currentPage++;
      this.canLoad = this.currentPage < this.totalPages;
      this.toggleLoading(true);
      const collectionID = this.dataset.collectionId;
      const res = await fetchCountDown(collectionID);

      const url = this.dataset.url;
      const dataUrl = `${url}?page=${this.currentPage}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        this.toggleLoading(false);
        const dom = generateDomFromString(html);
        const products = dom.querySelector(this.selectors.productsContainer);
        const oldCards = this.domNodes.productsContainer.childElementCount;
        let isAppended = false;

        if (products) {
          Array.from(products.childNodes).forEach((product) => {
            this.domNodes.productsContainer.appendChild(product);
            const check = setInterval(() => {
              if (this.domNodes.productsContainer.childElementCount > oldCards) {
                clearInterval(check);
                isAppended = true;
              }
            }, 50);
          });
        }

        if (this.enableFlashsale && res.ok && res.payload && res.payload.length) {
          const { expires_date } = res.payload[0];
          this.expires_date = expires_date;
          const check = setInterval(() => {
            if (isAppended) {
              clearInterval(check);
              const cards = this.domNodes.productsContainer.querySelectorAll(".m-product-card");
              cards.forEach((card) => {
                const content = card.querySelector(".m-product-card__content");
                const progress = card.querySelector(".m-product-sale-progress");
                if (!progress) {
                  let soldNumber;
                  if (card.dataset.soldNumber) {
                    soldNumber = card.dataset.soldNumber;
                  }
                  const component = saleProgress(res.payload[0], card.dataset.productId, soldNumber);
                  const newComponent = generateDomFromString(component);
                  content.appendChild(newComponent);
                }
              });
            }
          }, 50);
        }

        this.triggerLoad = false;

        if (!this.canLoad) {
          this.domNodes.loadMoreBtn && this.domNodes.loadMoreBtn.classList.add("m:hidden");
        }
      });
    }

    toggleLoading(status) {
      if (!this.domNodes.loadMoreBtn) return;
      if (status) {
        this.domNodes.loadMoreBtn.classList.add("m-spinner-loading");
      } else {
        this.domNodes.loadMoreBtn.classList.remove("m-spinner-loading");
      }
    }

    async initFlashSale() {
      const collectionID = this.dataset.collectionId;
      const res = await fetchCountDown(collectionID);
      if (res.ok && res.payload && res.payload.length) {
        const { expires_date } = res.payload[0];
        this.expires_date = expires_date;
        this.domNodes.products.forEach((card) => {
          const content = card.querySelector(".m-product-card__content");
          const pcardSale = card.querySelector(".m-product-sale-progress");
          let soldNumber;
          if (card.dataset.soldNumber) {
            soldNumber = card.dataset.soldNumber;
          }
          const component = saleProgress(res.payload[0], card.dataset.productId, soldNumber);
          const newComponent = generateDomFromString(component);
          if (!pcardSale) {
            content.appendChild(newComponent);
          }
        });
        this.initCountDown();
      }
    }

    initCountDown() {
      const endTime = new Date(this.expires_date).getTime();
      this.countDownTimer = new CountdownTimer(this.domNodes.countDown, Date.now(), endTime, {
        loop: true,
      });
    }
  }

  customElements.define("m-featured-collection", MFeaturedCollection);
}
